"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * A hook to sync state to local storage so that is persists through page refreshes
 * @param key used to lookup value
 * @param initialValue value to be saved to local storage
 * @see https://usehooks.com/page/3
 * @example
 * function App() {
 *   // Similar to useState but first arg is key to the value in local storage.
 *   const [name, setName] = useLocalStorage<string>('name', 'Bob');
 *
 *   return (
 *     <div>
 *       <input
 *         type="text"
 *         placeholder="Enter your name"
 *         value={name}
 *         onChange={e => setName(e.target.value)}
 *       />
 *     </div>
 *   );
 * }
 */
function useLocalStorage(key, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    var _a = react_1.useState(function () {
        try {
            // Get from local storage by key
            var item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            // If error also return initialValue
            console.log(error);
            return initialValue;
        }
    }), storedValue = _a[0], setStoredValue = _a[1];
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    var setValue = function (value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        }
        catch (error) {
            // A more advanced implementation would handle the error case
            console.log(error);
        }
    };
    return [storedValue, setValue];
}
exports.default = useLocalStorage;
//# sourceMappingURL=useLocalStorage.js.map